import React from 'react'
import { useTranslation } from 'react-i18next'
import banka10 from '../../assets/banka10.png'
import banka30 from '../../assets/banka30.png'
import banka100 from '../../assets/banka100.png'
const Buy = () => {
  const { t } = useTranslation()

  const products = [
    { id: 1, amount: t('buy.pack1'), price: '25€', img: banka10 },
    { id: 2, amount: t('buy.pack2'), price: '50€', img: banka30 },
    { id: 3, amount: t('buy.pack3'), price: '140€', img: banka100 },
  ]

  return (
    <section className="buy" id="buy">
      <div className="container">
        <h2>{t('buy.title')}</h2>
        <div className="product-list">
          {products.map(p => (
            <div key={p.id} className="product-card">
              <img src={p.img} alt={p.amount} />
              <h3>{p.amount}</h3>
              <p>{p.price}</p>
              <a href="#contact" className="btn-outline">{t('buy.cta')}</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Buy
